import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-448efff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = { class: "date-picker-container" }
const _hoisted_4 = { class: "date-picker" }
const _hoisted_5 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_6 = { class: "date-picker" }
const _hoisted_7 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-sync fas" }, null, -1))
const _hoisted_10 = { class: "list-images" }
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_download_thumbnails_button = _resolveComponent("download-thumbnails-button")!
  const _component_NoDataComponent = _resolveComponent("NoDataComponent")!
  const _component_sampling_point_image_component = _resolveComponent("sampling-point-image-component")!
  const _component_observer_component = _resolveComponent("observer-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    "destroy-on-close": "",
    title: _ctx.title
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_11, [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_tooltip, {
              content: _ctx.paramsVisible ? 'Ocultar parámetros' : 'Mostrar parámetros',
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "water-params-header",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args)))
                }, [
                  _createElementVNode("em", {
                    class: _normalizeClass(["el-icon", _ctx.paramsVisible ? 'el-icon-eye fas' : 'el-icon-eye-slash fas'])
                  }, null, 2)
                ])
              ]),
              _: 1
            }, 8, ["content"]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(), _createBlock(_component_el_date_picker, {
                modelValue: _ctx.fromDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fromDate) = $event)),
                type: "datetime",
                placeholder: "DD/MM/YYYY HH:mm",
                key: _ctx.dateKey,
                format: "DD/MM/YYYY HH:mm"
              }, {
                default: _withCtx((cell) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cell", { current: cell.isCurrent }])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                    }, _toDisplayString(cell.text), 3),
                    (_ctx.hasEstimatedData(cell.date))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_component_el_date_picker, {
                modelValue: _ctx.toDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toDate) = $event)),
                type: "datetime",
                placeholder: "DD/MM/YYYY HH:mm",
                key: _ctx.dateKey,
                format: "DD/MM/YYYY HH:mm"
              }, {
                default: _withCtx((cell) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cell", { current: cell.isCurrent }])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                    }, _toDisplayString(cell.text), 3),
                    (_ctx.hasEstimatedData(cell.date))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            ])
          ])
        ]),
        _createVNode(_component_el_button, {
          class: "btn",
          type: "primary",
          size: "default",
          circle: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchImages())),
          title: "Filtrar por fechas"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "btn",
          type: "primary",
          size: "default",
          circle: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshDatePickers())),
          title: "Limpiar filtros"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_download_thumbnails_button, {
          "start-date": _ctx.fromDate ? new Date(_ctx.fromDate) : null,
          "end-date": _ctx.toDate ? new Date(_ctx.toDate) : null,
          id: _ctx.id,
          labelling: "CORRECT"
        }, null, 8, ["start-date", "end-date", "id"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.images.length === 0)
          ? (_openBlock(), _createBlock(_component_NoDataComponent, {
              key: 0,
              message: 'No hay imágenes en el rango seleccionado'
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_sampling_point_image_component, {
          images: _ctx.images,
          colourCode: _ctx.colourCode,
          title: _ctx.getSamplingPointName(),
          "params-visible": _ctx.paramsVisible
        }, null, 8, ["images", "colourCode", "title", "params-visible"]),
        (_ctx.hasMore)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.isSearching)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    primary: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showMore()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("btn.showMore")), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    primary: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMoreSearch()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("btn.showMore")), 1)
                    ]),
                    _: 1
                  })),
              (!_ctx.isSearching)
                ? (_openBlock(), _createBlock(_component_observer_component, {
                    key: 2,
                    onIntersect: _ctx.showMore
                  }, null, 8, ["onIntersect"]))
                : (_openBlock(), _createBlock(_component_observer_component, {
                    key: 3,
                    onIntersect: _ctx.showMoreSearch
                  }, null, 8, ["onIntersect"]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}